const selects = () => {
  const selectors = [
    {
      id: "#ExaminationAreaId",
      placeholder: "Выберите из списка",
    },
    {
      id: "#ExamType",
      placeholder: "Выберите из списка",
    }
  ];

  selectors.forEach((item) => {
    let selector = $(item.id),
      message = "",
      placeholder;
    
    message = "Ничего не найдено";
    placeholder = item.placeholder;

    selector.select2({
      placeholder: placeholder,
      minimumResultsForSearch: item.id == "#ExamType" ? '-1' : '',
      language: {
        noResults: function () {
          return message;
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    selector.val(null).trigger("change");
  });
};

export default selects;
